@if (isLoading) {
  <exl-citation-brief-placeholder [copies]="2" class="content-placeholders">
  </exl-citation-brief-placeholder>
}

@for (award of awards; track trackByIndex(i, award); let i = $index) {
  <exl-citation-brief
    style="display: block"
    [title]="getGrantTitle(award)"
    type="research.awards.grant.type"
    [postType]="getPostType(award)"
    [titleUrl]="award.grantURL"
    [titleClickable]="!!award.grantURL"
    [titleHeaderLevel]="3"
    [menuActions]="getMenuAction(award)"
    [hidden]="!profileService.isPublicPage && (!award.isVisibleInProfiles || !award.displayInPublicProfile)"
    (actionClick)="onActionClick($event, award, i)"
    >
    <p class="margin-zero semibold">
      @if (award.funderURL) {
        <a [href]="award.funderURL" target="_blank" class="hasnt-color"
          >{{ award.funderCode | defaultTranslate : { default: award.funderName } }}
          @if (award.funderAgencyCode) {
            ({{ award.funderAgencyCode | defaultTranslate : { default: award.funderAgencyName } }})
          }
        </a>
      }
      @if (!award.funderURL) {
        {{ award.funderCode | defaultTranslate : { default: award.funderName } }}
        @if (award.funderAgencyCode) {
          ({{ award.funderAgencyCode | defaultTranslate : { default: award.funderAgencyName } }})
        }
      }
    </p>
    <p>{{ 'research.awards.grant.id' | translate }} {{ award.grantId }}.</p>
    <p>{{ getInvestigatorsStr(award) }}</p>
    @if (!award.displayInPublicProfile) {
      <ng-container slot="additional-status-tags">
        <mulo-status-tag [description]="'research.profile.hide.status.hidden.tooltip' | translate">
          {{ 'research.profile.hide.status.hidden' | translate }}
        </mulo-status-tag>
      </ng-container>
    }
    @if (showHighlightButton(award)) {
      <ng-container exl-slot-custom-actions>
        <exl-button-splash
          [splashIcon]="!award.isHighlight ? 'star' : 'star-outline'"
          (clicked)="onHighlightClick(award)"
          [color]="award.isHighlight || award.highlightHover ? 'primary' : null"
          [matTooltip]="getHighlightsTooltip(award) | translate"
          [ariaLabel]="getHighlightsTooltip(award)"
          (mouseenter)="award.highlightHover = true"
          (mouseleave)="award.highlightHover = false"
          >
          @if (award.isHighlight && award.highlightHover) {
            <mat-icon svgIcon="star-off"></mat-icon>
          }
          @if (award.isHighlight && !award.highlightHover) {
            <mat-icon svgIcon="star"></mat-icon>
          }
          @if (!award.isHighlight) {
            <mat-icon svgIcon="star-outline"></mat-icon>
          }
        </exl-button-splash>
      </ng-container>
    }
    @if (!profileService.isPublicPage && !award.isVisibleInProfiles) {
      <div class="visibility">
        <mat-icon
          muloSvgViewbox
          svgIcon="person-off"
          class="margin-right-xs"
          [matTooltip]="'research.visibility.noProfiles' | translate"
        ></mat-icon>
        <span>{{ 'research.visibility.noProfiles' | translate }}</span>
      </div>
    }
  </exl-citation-brief>
}
